import { makeStyles } from '@material-ui/core/styles';
import { em } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& p, h1, h2, h3, h4, h5, h6': {
        marginTop: 0,
      },
    },
    noTitle: {
      '&': {
        [muiTheme.breakpoints.up('md')]: {
          marginBottom: '24px',
        },
      },
    },
    gridItem: {
      alignItems: 'flex-start',
      display: 'flex',
      flexBasis: '45%',
      paddingRight: muiTheme.spacing(2),
      marginBottom: muiTheme.spacing(2),

      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          flexBasis: '100% !important',
          maxWidth: '100% !important',
          marginBottom: '24px',
        },
      },
      '& h5': {
        display: 'flex',
        flexWrap: 'wrap',
      },
      '&:nth-of-type(odd)': {
        [muiTheme.breakpoints.down('sm')]: {
          marginRight: '0',
        },
      },
    },
    gridMultiRow: {
      '& $gridItem:first-of-type, $gridItem:nth-of-type(2)': {
        marginBottom: '80px',

        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: '24px',
        },
      },
    },
    gridItemNoMargin: {
      margin: '0 !important',
      padding: '0 !important',
    },
    statsGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: 0,
      paddingInlineStart: 0,
    },
    statsGridNoTitle: {
      justifyContent: 'center',
    },
    leftGroup: {
      paddingRight: '42px',
      '& h1, h2, h3, h4, h5, h6': {
        ...muiTheme.typography.h2,
        marginBottom: '24px',
      },
    },
    leftGroupLogo: {
      marginBottom: '24px',
    },
  }),
  { name: 'GenDynamicStats' },
);

export default useStyles;
